/* @flow weak */

'use strict';

const React = require('react');
const ControlMixin = require('../../mixins/ControlMixin.jsx');

const _NotFound = React.createClass({
  mixins: [ControlMixin],

  render() {
    return (
      <div className="uc-control">
        The control {this.props.question.control} was not found for question {this.props.question.name}.
      </div>
    );
  }
});

module.exports = _NotFound;


// WEBPACK FOOTER //
// ./src/base/scripts/components/controls/_NotFound.jsx